import { Table } from 'semantic-ui-react';
import { AssignedRoomSeatLimit } from './AssignedRoomSeatLimit';
import { AssignedLrwRoomDto } from 'api/planning';
import { useIntParam, useLrwSessionAllowedActions } from 'hooks';
import { Button } from '@britishcouncil/react-admin';
import { ROUTING_PATHS } from 'const';
import { generatePath, useNavigate } from 'react-router';

type Props = {
  room: AssignedLrwRoomDto;
  seatLimitSum: number;
  currentlyUpdatedRoom: number | undefined;
  setCurrentlyUpdatedRoom: (roomId: number | undefined) => void;
};

export const LrwSessionRoomRow = ({
  room,
  seatLimitSum,
  currentlyUpdatedRoom,
  setCurrentlyUpdatedRoom,
}: Props) => {
  const sessionId = useIntParam('sessionId');
  const { canRemoveRoom } = useLrwSessionAllowedActions();
  const { removeLrwSessionRoom } = ROUTING_PATHS;
  const navigate = useNavigate();
  const canRemoveThisRoom = canRemoveRoom && room.registrationsCount === 0;

  const onRemoveRoomClick = () => {
    if (canRemoveThisRoom) {
      navigate(
        generatePath(removeLrwSessionRoom.absolutePath, { sessionId, sessionRoomId: room.id })
      );
    }
  };

  return (
    <Table.Row>
      <Table.Cell>{room.agentName ?? '-'}</Table.Cell>
      <Table.Cell>{room.buildingName}</Table.Cell>
      <Table.Cell>{room.floor}</Table.Cell>
      <Table.Cell>{room.name}</Table.Cell>
      <Table.Cell>{room.registrationsCount}</Table.Cell>
      <Table.Cell>{room.totalSeats}</Table.Cell>
      <Table.Cell>
        <AssignedRoomSeatLimit
          seatLimitSum={seatLimitSum}
          roomId={room.id}
          editedRoomId={currentlyUpdatedRoom}
          setEditedRoomId={setCurrentlyUpdatedRoom}
          originalSeatLimit={room.seatLimit}
          totalSeats={room.totalSeats}
          registrationsCount={room.registrationsCount}
        />
      </Table.Cell>
      <Table.Cell textAlign="center" verticalAlign="middle">
        <Button
          data-testid="remove-room-button"
          compact
          opaque
          icon="trash alternate"
          size="large"
          color="red"
          onClick={onRemoveRoomClick}
          disabled={!canRemoveThisRoom}
        />
      </Table.Cell>
    </Table.Row>
  );
};
